const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/actions/nativeActions.ts';
import { Action } from 'redux';

export const OPEN_EXTERNAL_BROWSER = 'OPEN_EXTERNAL_BROWSER';

export interface IOpenExternalBrowserAction extends Action {
    payload: {
        url: string;
        title?: string;
        prelocked: boolean;
    };
}

/**
 * Causes the native wrapper to open the specified url in a separate browser instance
 */
export function openExternalBrowser(
    url: string,
    title?: string,
    prelocked: boolean = false
): IOpenExternalBrowserAction {
    return {
        type: OPEN_EXTERNAL_BROWSER,
        payload: { url, title, prelocked },
    };
}
